// import React from 'react';

// export type RatingsV2Props = {
//   /**
//    * a text to be rendered in the component.
//    */
//   text: string
// };

// export function RatingsV2({ text }: RatingsV2Props) {
//   return (
//     <div>
//       {text}
//     </div>
//   );
// }

// import React from 'react';

// export type RatingsProps = {
//   /**
//    * a text to be rendered in the component.
//    */
//   text: string
// };

// export function Ratings({ text }: RatingsProps) {
//   return (
//     <div>
//       {text}
//     </div>
//   );
// }

import React, {useState, useEffect} from "react";
import RatingsState, { StackType } from "./ratings-state";
import { IconSvg, IconSvgSizes } from "@att-bit/duc.components.icon-svg";
import { startIcon, thumbsUpIcon, thumbsDownIcon } from "./constants";
import { Button } from "@att-bit/duc.components.button-base";
/* DUC Button cyclic Dependencies */
//import { Button, ButtonVariant } from "@att-bit/duc.components.button";
export type RatingsProps = {
  /**
   *  ref for the Video
   */
  ref?: any;
  /**
   *  Data for Ratings
   */
  data: RatingsData;
  /**
   *  Events for the Ratings
   */
  events?: RatingsEvents;
  /**
   *  Additional options for Ratings to enable different interfaces like Model etc.
   */
  options?: RatingsOptions;
  /**
   *  Additional id passed to Ratings
   */
  testId?: string;
};

export type RatingsData = {
  type: string;
};

export type RatingsOptions = {
  hidden?: boolean;
};

export type RatingsEvents = {
  submitted(submitted: boolean, rating: number, feedback: string): any;
};

export enum RatingType {
  STARS = "stars",
  THUMBS = "Thumbs",
  // THUMBS_INLINE= 'Thumbs_inline',
}

export const Ratings = (props:RatingsProps, stateObj:RatingsState) => {
  const [rating, setRating] = useState<number>(0);
  const [error, setError] = useState<boolean>();
  const [submitted, setSubmitted] = useState<boolean>();
  const [commnentTextRef, setCommentTextRef] = useState<any>(React.createRef());
  const [feeback, setFeeback] = useState<string>();
  const [display, setDisplay] = useState<boolean>();
  const [state, setState] = useState({
    stack: StackType.RATING_PANEL,
  })
  const [ratingStyles, setRatingStyles] = useState(
    /*
    // @ts-ignore */
    <style jsx global>{`
    .Ratings__container {
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1em;
      flex-direction: column;
      color: #fff;
      flex: 0 0 auto;
    }
    
    .Ratings__panel {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      overflow: hidden;
    }

    .Ratings__panel .btn-secondary {
      margin-right: 10px;
    }
    
    .Ratings__comments {
      max-width: 600px;
      width: 100%;
    }
    
    .Ratings__open {
      animation-duration: 0.75s;
      animation-fill-mode: both;
      animation-name: Ratings__slideIn;
    }
    
    .Ratings__close {
      animation-duration: 0.75s;
      animation-fill-mode: both;
      animation-name: Ratings__slideOut;
    }
    
    .Ratings__star {
      width: 27px;
      height: 27px;
      max-width: 27px;
      max-height: 27px;
      padding: 3px;
      margin: 0;
      background: transparent;
      border: 0;
      color: gray;
      font-size: 23px;
    }
    
    .Ratings__down {
    }
    
    @keyframes Ratings__slideIn {
      from {
        max-height: 0;
      }
      to {
        max-height: 300px;
      }
    }
    
    @keyframes Ratings__slideOut {
      from {
        max-height: 300px;
      }
      to {
        max-height: 0;
      }
    }
    
    .Ratings__button,
    .Ratings__cancel,
    .Ratings__submit {
      background-color: transparent;
      background-clip: padding-box;
      border: 1px solid transparent;
      border-radius: 18px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
      cursor: pointer;
      display: inline-block;
      font-size: 1em;
      font-weight: normal;
      max-width: 470px;
      min-width: 70px;
      padding: 10px;
      position: relative;
      text-align: center;
      vertical-align: middle;
      white-space: nowrap;
      overflow: hidden;
      box-sizing: border-box;
      margin-left: 7px;
      margin-top: 7px;
    }
    
    .Ratings__cancel {
      border: 1px solid #d2d2d2;
      background-color: #f2f2f2;
      background: linear-gradient(to bottom, #fcfcfc 0%, #f2f2f2 100%);
      color: #009fdb;
      box-shadow: 0 5px 5px -5px rgba(0, 0, 0, 0.15);
    }
    
    .Ratings__cancel:hover {
      color: #009fdb;
      outline-color: #000 !important;
      background: linear-gradient(to bottom, #f2f2f2 0%, #fcfcfc 100%);
    }
    
    .Ratings__submit {
      border-color: #00b1ed transparent #009fdb;
      background: #009fdb;
      color: #fff;
    }
    
    .Ratings__submit:hover {
      border-color: #0098cb transparent #0098cb;
      outline-color: #fff !important;
      background: #0098cb;
      color: #fff;
    }
    
    /*
    text inputs
    */
    .Ratings__input {
      box-sizing: border-box;
      width: 100%;
      min-width: 0;
      border-radius: 6px;
      border: 1px solid #d2d2d2;
      box-shadow: -1px 3px 2px -2px rgba(0, 0, 0, 0.08) inset;
      transition: border 0.3s linear 0s;
      margin: 0 !important;
      padding: 10px !important;
      font-size: 1em;
      resize: none;
      flex: 1 1 auto;
    }
    
    .Ratings__input:focus {
      border: 1px solid #d2d2d2;
      outline: 0;
      box-shadow: inset 0 0 0 3px #009fdb;
    }
    
    .Ratings__input.Ratings__error {
      /* Remove the border for iOS */
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      box-shadow: inset 0 0 0 3px #cf2a2a;
      outline: 0;
    }
    
    textarea {
      min-height: 70px;
    }
    @media (min-width: 300px) {
      .Ratings__type-base.Ratings__pad-b-xxs {
        /* padding: 12px !important; */
        /* font-size: 1.3rem; */
        margin-left: 12px;
        margin-right: 12px;
      }
    }
    
    .Ratings__ratingsHelp {
      margin-left: 0px;
      margin-right: 0px;
      line-height: 1.6;
      font-size: 1.6rem;
      padding-bottom: 8px !important;
    }
    
    @media (max-width: 360px) {
      .Ratings__ratingsHelp {
        /* padding: 12px !important; */
        /* font-size: 1.3rem; */
        margin: 12px;
        font-size: 1.6rem;
      }
    }    
    `}</style>
  );
  
  const [ratingsGvpIconsStyles, setRatingsGvpIconsStyles] = useState(
    /*
    // @ts-ignore */
    <style jsx global>{`
    .gvp-icons__gvp-icon {
      font-family: "gvp-icon";
      display: inline-block;
      vertical-align: middle;
      line-height: 1;
      font-weight: normal;
      font-style: normal;
      speak: none;
      text-decoration: inherit;
      text-transform: none;
      text-rendering: auto;
      -moz-osx-font-smoothing: grayscale;
      -webkit-font-smoothing: antialiased;
    }
    
    .gvp-icons__gvp-icon-lg {
      vertical-align: -15%;
      line-height: 0.75em;
      font-size: 1.33333333em;
    }
    
    .gvp-icons__gvp-icon-CameraButton::before {
      content: "\ea01";
    }
    
    .gvp-icons__gvp-icon-Caption::before {
      content: "\ea05";
    }
    
    .gvp-icons__gvp-icon-Close::before {
      content: "\ea02";
    }
    
    .gvp-icons__gvp-icon-ClosePanelButton::before {
      content: "\ea04";
    }
    .gvp-icons__gvp-icon-FilterIcon::before {
      content: "\ea03";
    }
    
    .gvp-icons__gvp-icon-FullScreen_collaps::before {
      content: "\ea07";
    }
    
    .gvp-icons__gvp-icon-FullScreen_expand::before {
      content: "\ea06";
    }
    
    .gvp-icons__gvp-icon-LoaderButton::before {
      content: "\ea0b";
    }
    
    .gvp-icons__gvp-icon-PauseButton::before {
      content: "\ea08";
    }
    
    .gvp-icons__gvp-icon-PlayButton::before {
      content: "\ea09";
    }
    
    .gvp-icons__gvp-icon-PlayButtonWithCircle::before {
      content: "\ea0a";
    }
    
    .gvp-icons__gvp-icon-PrintButton::before {
      content: "\ea0c";
    }
    
    .gvp-icons__gvp-icon-ReplayButton::before {
      content: "\ea0d";
    }
    
    .gvp-icons__gvp-icon-SoundIcon_mute::before {
      content: "\ea0e";
    }
    
    .gvp-icons__gvp-icon-SoundIcon_oneWave::before {
      content: "\ea0f";
    }
    
    .gvp-icons__gvp-icon-SoundIcon_threeWave::before {
      content: "\ea11";
    }
    
    .gvp-icons__gvp-icon-SoundIcon_twoWave::before {
      content: "\ea13";
    }
    
    .gvp-icons__gvp-icon-StarsIcon::before {
      content: "\ea10";
    }
    
    .gvp-icons__gvp-icon-ThumbsDown::before {
      content: "\ea14";
    }
    
    .gvp-icons__gvp-icon-ThumbsUp::before {
      content: "\ea12";
    }
    
    .gvp-icons__gvp-icon-Transcript_collapse::before {
      content: "\ea15";
    }
    
    .gvp-icons__gvp-icon-Transcript_expand::before {
      content: "\ea16";
    }    
    `}</style>
  );

  const [ratingContollerStyles, setRatingContollerStyles] = useState(
    /*
    // @ts-ignore */
    <style jsx global>{`
    .Controller__controller {
      flex: 0 0 auto;
      -ms-flex: 0 0 auto;
      display: flex;
      align-items: center;
      min-height: 40px;
      clear: both;
      position: relative;
      width: 100%;
      flex-shrink: 0;
      flex-wrap: wrap;
      justify-content: space-between;
      /*padding 1 fixes weird sub-pixel aliasing*/
      padding: 1px;
      border-radius: 0 0 7px 7px;
    }
    
    .Controller__container {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0px 10px;
    }
    .Controller__container.Controller__large {
      margin: 10px;
    }
    .Controller__container:first-child {
      margin-left: 0;
    }
    .Controller__container:nth-last-child(2) {
      margin-right: 0;
    }
    
    .Controller__button {
      flex: 1 1 auto;
      padding: 0 3px;
      order: 1;
      margin: 0 3px;
      height: 35px;
      max-height: 35px;
      order: 1;
      font-size: 1em;
      fill: #999999;
      border-radius: 3px;
      border: 0;
      font-size: 35px;
      cursor: pointer;
      background-color: transparent;
      width: 45px;
      max-width: 45px;
    }
    .Controller__button.Controller__large {
      height: 35px;
      max-height: 45px;
    }
    .Controller__button:first-child {
      margin-left: 0;
    }
    .Controller__button.Controller__down svg{
      color: #009fdb;
    }
    .Controller__button svg:hover {
      color: #009fdb;
    }
    
    .Controller__range {
      flex: 1 1 auto;
      padding: 0 3px;
      order: 1;
      margin: 0 3px;
      height: 35px;
      max-height: 35px;
      order: 1;
      color: #fff;
      font-size: 1em;
      margin: 0;
    }
    .Controller__range.Controller__large {
      height: 35px;
      max-height: 45px;
    }
    .Controller__range:first-child {
      margin-left: 0;
    }
    .Controller__range:last-child {
      padding-left: 10px;
    }
    
    .Controller__text {
      flex: 1 1 auto;
      padding: 0 3px;
      order: 1;
      margin: 0 3px;
      height: 35px;
      max-height: 35px;
      order: 1;
      color: #fff;
      font-size: 1em;
      height: auto;
      max-height: none;
      text-align: center;
    }
    .Controller__text.Controller__large {
      height: 35px;
      max-height: 45px;
    }
    .Controller__text:first-child {
      margin-left: 0;
    }
    
    .Controller__flexible {
      flex: 1 1 auto;
    }
    
    .Controller__inflexible {
      flex: 0 0 auto;
    }
    
    .Controller__volumeMaxMinWidth {
      max-width: 60px !important;
      min-width: 60px;
    }
    @media screen and (max-width: 600px) {
      .Controller__controller .Controller__extra {
        display: none;
      }
      
      .Controller__controller .Controller__range:first-child {
        margin-left: 0;
      }
      
      .Controller__controller .Controller__range:last-child {
        display: none;
      }
    }
    
    @media screen and (max-width: 400px) {
      .Controller__controller .Controller__important {
        order: 0;
      }
    }
    @media screen and (max-width: 250px) {
      .Controller__controller .Controller__item {
        margin: 0;
        padding: 0;
      }    
    }
    `}</style>
  );

  const generate = (input: number): any => {
    let rule = "Ratings__panel font-regular";
    if (typeof display !== 'undefined') {
      rule += (display ? ' ' + "Ratings__open" : ' ' + "Ratings__close");
    }
    switch (input) {
      case 0:
        return (
          <div className={rule}>
            <div className={"Ratings__panel"}>
              <div>How would you rate this video?</div>
              {genRatings()}
            </div>
          </div>
        );
      case 1:
        return (
          <div className={rule + ' ' + "Ratings__comments"}>
            {genCommentsPanel()}
          </div>
        );
      case 2:
        return (
          <div className={rule} style={{ height: 38 }}>
            Thank you for your feedback!
          </div>
        );
    }
  }

  const genRatings = (override?: string): any => {
    const cssStarClass = "Ratings__star";
    const cssThumbsClass = [
        !override ? "Controller__button" : '',
        rating === 5 || rating === 1 ? ' ' + "Controller__down" : '',
        "gvp-icons__gvp-icon",
    ];
    const cssDefaultThumbsClass = [
        !override ? "Controller__button" : '',
        ' ' + '',
        "gvp-icons__gvp-icon",
    ];
    switch (props.data.type) {
        case 'stars':
            return (
                <div style={{ marginLeft: 10 }}>
                    {(() => {
                        const stars = [];
                        for (let i = 1; i <= 5; i++) {
                            stars.push(
                                <button
                                    className={
                                        cssStarClass +
                                        ' ' +
                                        (rating >= i ? ' ' + "Ratings__down color-att-blue" : '')
                                    }
                                    key={i}
                                    onClick={rate}
                                    aria-label={i + ' Stars'}
                                    report-title="starRating"
                                    start-rating={i}
                                    data-rating={i}
                                >
                                    <IconSvg size={IconSvgSizes.SM} svgNodeStr={startIcon} altText={'star Icon Ratings'}/>
                                </button>,
                            );
                        }
                        return stars;
                    })()}
                </div>
            );
        default:
            return (
                <div style={{ marginLeft: 10 }}>
                    <button
                        className={
                            rating === 5 || rating === 0
                                ? cssThumbsClass.join(' ') +
                                  ' ' 
                                : cssDefaultThumbsClass.join(' ') +
                                  ' ' 
                        }
                        onClick={rate}
                        aria-label="Thumbs Up"
                        report-title="Thumbs up"
                        data-rating={5}>
                      <IconSvg 
                        size={IconSvgSizes.SM} 
                        svgNodeStr={thumbsUpIcon} altText={'Thumbs up Icon Ratings'}/>
                    </button>
                    <button
                        className={
                          rating === 1 || rating === 0
                              ? cssThumbsClass.join(' ') +
                                ' ' 
                              : cssDefaultThumbsClass.join(' ') +
                                ' ' 
                        }
                        onClick={rate}
                        aria-label="Thumbs Down"
                        report-title="Thumbs down"
                        data-rating={1}
                    >
                      <IconSvg size={IconSvgSizes.SM} svgNodeStr={thumbsDownIcon} altText={'Thumbs down Icon ratings'}/>
                      </button>
                </div>
            );
    }
  }

  const genCommentsPanel = (): any => {
    return (
      <div>
        <div className={"Ratings__ratingsHelp"}>Help us improve our content by giving us feedback:</div>
        <textarea
          style={{ width: '100%', minWidth: 200, display: 'inline' }}
          className={"Ratings__input bg-white color-black" + (error ? ' ' + "Ratings__error" : 'line-h-md')}
          aria-label="Comments"
          placeholder="Please comment here"
          ref={commnentTextRef}
        />
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', paddingTop:'8px' }}>
          <Button
            variant={'secondary'}
            onClick={close}
          >Cancel</Button>
          <Button
            report-title={props.data.type === RatingType.STARS ? 'starRating' : (rating === 5 ? 'Thumbs up' : 'Thumbs down')}
            start-rating={rating}
            onClick={submit}
          >Submit</Button>
        </div>
      </div >
    );
  }

  const submit = () => {
    setError(false);
    if (commnentTextRef && commnentTextRef.current && commnentTextRef.current.value) {
      setFeeback(commnentTextRef && commnentTextRef.current && commnentTextRef.current.value);
      setDisplay(false);
      
      setTimeout(() => {
        let tempstate = state;
        tempstate["stack"] = StackType.THANKYOU_PANEL;
        setState({...tempstate});
        setSubmitted(true);
        exit();
      }, 750);
    } else {
      setError(true);
      reset(true);
    }
  }

  const close = () => {
    setError(false);
    setDisplay(false);
    setTimeout(() => {
      let tempstate = state;
        tempstate["stack"] = StackType.RATING_PANEL;
        setState({...tempstate});
    }, 750);
  }

  const exit = () => {
    setDisplay(false);
    let tempstate = state;
    tempstate["stack"] = StackType.EXIT;
    setState({...tempstate});
    props.events.submitted(true, rating, feeback);
  }

  const rate = (e: React.FormEvent<HTMLButtonElement>) => {
    let temprating = rating;
    temprating =  parseInt(e.currentTarget.getAttribute('data-rating'))!;
    setRating(temprating);
    setTimeout(() => {
      let tempstate = state;
      tempstate["stack"] = StackType.COMMENT_PANEL;
      setState({...tempstate});
    }, 750);
  }

  const reset = (clean?: boolean) => {
    setDisplay(false);
  }
 
  useEffect(() => {
    setDisplay(stateObj.stack !== state.stack)
  }, [state]);

  return (
    <>
      {props.options && props.options.hidden ? 
        <>
          {ratingStyles}
          {ratingsGvpIconsStyles}
          {ratingContollerStyles}
            <div className={"Ratings__container"} />
        </>
      :
        <>
          {ratingStyles}
          {ratingsGvpIconsStyles}
          {ratingContollerStyles}
            <div role="group" className={"Ratings__container"} >
              {!submitted && generate(state.stack)}
            </div>
        </>
      }
    </>
  );

}
export default Ratings;